const CRM_COUNTRIES = [
  {
    name: "Ukraine",
    code: "com",
  },
  {
    name: "Bulgaria",
    code: "bg",
  },
  {
    name: "Czech Republic",
    code: "cz",
  },
  {
    name: "Germany",
    code: "de",
  },
  {
    name: "Spain",
    code: "es",
  },
  {
    name: "Hungary",
    code: "hu",
  },
  {
    name: "Lithuania",
    code: "lt",
  },
  {
    name: "Latvia",
    code: "lv",
  },
  {
    name: "Netherlands",
    code: "nl",
  },
  {
    name: "Poland",
    code: "pl",
  },
  {
    name: "United Kingdom",
    code: "uk",
  },
  {
    name: "Slovakia",
    code: "sk",
  },
  {
    name: "Canada",
    code: "ca",
  },
  {
    name: "Romania",
    code: "ro",
  },
  {
    name: "Estonia",
    code: "ee",
  },
];

const localStorageKeys = {
  selectedCountry: "selected_country",
}

export { CRM_COUNTRIES, localStorageKeys };
